import { render, staticRenderFns } from "./NotificationsList.vue?vue&type=template&id=392f3ebf&"
import script from "./NotificationsList.vue?vue&type=script&lang=js&"
export * from "./NotificationsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/piscinaFacilDev/piscinapp-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('392f3ebf')) {
      api.createRecord('392f3ebf', component.options)
    } else {
      api.reload('392f3ebf', component.options)
    }
    module.hot.accept("./NotificationsList.vue?vue&type=template&id=392f3ebf&", function () {
      api.rerender('392f3ebf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/notifications/NotificationsList.vue"
export default component.exports